import * as yup from "yup";


const FinancialKnowledgeSchema = yup.object().shape({
    familiarWithD2I: yup.string().min(2).required('Answer Required'),
    financialPlanInPlace: yup.string().min(2).required('Answer Required'),
    experienceLevel: yup.string().min(2).required('Answer Required'),
    attendedCoursesOrWorkshops: yup.string().min(2).required('Field is Required'),
    workedWithAdvisor: yup.string().min(2).required('Answer Required'),
    savingForRetirement: yup.string().min(2).required('Answer Required'),
    usingToolsOrApps: yup.string().min(2).required('Answer Required'),
    amountPerMonth: yup.string()
});


export default FinancialKnowledgeSchema;